import { useQuery } from '@tanstack/react-query';

import getDailyLog from 'Api/monitoring/getDailyLog';

import getDailyLogResponse from './model/response/getDailyLogResponse';
import getDailyLogRequest from './model/request/getDailyLogRequest';

const useGetDailyLog = (id) => {
  return useQuery({
    queryKey: ['daily-log', id],
    queryFn: async () => {
      const queries = getDailyLogRequest({ id });

      const response = await getDailyLog(queries);

      const result = getDailyLogResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: !!id,
  });
};

export default useGetDailyLog;
